import { create } from 'zustand';

// Qual quadro esta com o dialogo de senha aberto.
//
// POR QUE UMA STORE, e nao useState dentro do BoardItemMenu: pelo
// clique-direito o menu roda em modo CONTROLADO — quem decide se ele existe e
// o DraggableBoardItem (`renderContextMenu` so e chamado enquanto ctxPoint
// != null). Abrir o dialogo fecha o menu, o pai para de renderiza-lo, o
// BoardItemMenu DESMONTA e levaria junto qualquer estado local — o dialogo
// nunca chegava a aparecer. Pelo botao "..." funcionava, pelo clique-direito
// nao.
//
// Com o estado aqui fora e um host montado no App (BoardProtectionHost), o
// dialogo sobrevive ao desmonte do menu, e os dois lugares que montam o menu
// continuam ganhando o item "Proteger" de graca. Mesmo padrao de
// dialogStore.js + DialogHost.jsx, que o projeto ja usa pelo mesmo motivo.
const useBoardProtectionDialogStore = create((set) => ({
  // { id, name, is_protected } do quadro, ou null.
  board: null,
  open: (board) => set({ board }),
  close: () => set({ board: null }),
}));

export const boardProtectionDialog = {
  open: (board) => useBoardProtectionDialogStore.getState().open(board),
  close: () => useBoardProtectionDialogStore.getState().close(),
};

export default useBoardProtectionDialogStore;
